import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { isSessionExpired } from 'src/utils';
import { toast } from 'react-toastify';
import DashboardSidebar from './DashboardSidebar';
import DashboardNavbar from './DashboardNavbar';

const DashboardLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  }),
);

const DashboardLayoutWrapper = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
  }),
);

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
});

const DashboardLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
});

function DashboardLayout() {
  const navigate = useNavigate();
  const authState = useSelector((state) => state.authentication);
  const { user } = authState;

  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    }

    if (user) {
      const { sessionData } = user;
      if (sessionData && isSessionExpired(sessionData.expirationTime)) {
        navigate('/login', { replace: true });
        toast.warn('Session expired, please login again');
      }
    }
  });

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const openMobileNav = () => {
    setMobileNavOpen(true);
    console.log('Mobile nav opened');
  };

  return (
    <DashboardLayoutRoot>
      <DashboardNavbar onMobileNavOpen={openMobileNav} />
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Box sx={{ m: 3 }}>
              <Outlet />
            </Box>
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
}

export default DashboardLayout;
